import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class DashboardSkinGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    const requestedSkin = route.data['dashboardSkin'];

    return forkJoin({
      account: this.authenticationService.isUserAuthenticated(),
      plan: this.authenticationService.getPlanFeaturesEnabled(),
    }).pipe(
      map(({ account, plan }) => {
        const availableSkins = Array.isArray(plan?.available_dashboard_skins)
          ? plan.available_dashboard_skins
          : [];
        const hasAccess =
          account?.success === true &&
          availableSkins.includes(requestedSkin);

        if (!hasAccess) {
          this.router.navigate(['/dashboard']);
        }

        return hasAccess;
      }),
      catchError(() => {
        this.router.navigate(['/dashboard']);
        return of(false);
      })
    );
  }
}
